import { api } from "../../services/Api.js"

export function get_email_item({  state }, payload){

    // add token to payload
    payload.token=state.appSettings.token;
    
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    return api.post(school,"get_email_item.php",payload);
    
}